import { render, staticRenderFns } from "./TabCommentsInstallation.vue?vue&type=template&id=7838c5d1&"
import script from "./TabCommentsInstallation.vue?vue&type=script&lang=ts&"
export * from "./TabCommentsInstallation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports